export enum MeetingDisplayMode {
  Lecturer,
  Tiled,
  PureAudio,
}
